import React from "react";
import { ArrowLeft } from "lucide-react";

export default function CarouselsHeader({
  onBack,
  title,
  subTitle,
  subTitleElement,
  actions,
}) {
  return (
    <div className="bg-white border-b border-slate-200 px-4 md:px-6 py-4">
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2 md:gap-4 flex-1 min-w-0">
          <button
            onClick={onBack}
            className="inline-flex items-center gap-2 text-slate-600 hover:text-slate-900 transition-colors"
            aria-label="Go back"
          >
            <ArrowLeft className="w-4 h-4 text-gray-400" />
          </button>
          <div className="h-8 md:h-10 w-1 bg-gray-200 rounded-full flex-shrink-0" />
          <div className="flex items-center gap-2 min-w-0">
            <div className="h-7 w-7 md:h-8 md:w-8 flex items-center justify-center rounded-lg bg-blue-100 flex-shrink-0">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14 2H2M14 14H2M3.33333 8C3.33333 7.37874 3.33333 7.06812 3.43483 6.82309C3.57015 6.49638 3.82972 6.23682 4.15642 6.10149C4.40145 6 4.71208 6 5.33333 6L10.6667 6C11.2879 6 11.5986 6 11.8436 6.10149C12.1703 6.23682 12.4298 6.49639 12.5652 6.82309C12.6667 7.06812 12.6667 7.37874 12.6667 8C12.6667 8.62126 12.6667 8.93188 12.5652 9.17691C12.4298 9.50362 12.1703 9.76318 11.8436 9.89851C11.5985 10 11.2879 10 10.6667 10L5.33333 10C4.71208 10 4.40145 10 4.15642 9.89851C3.82972 9.76318 3.57015 9.50361 3.43483 9.17691C3.33333 8.93188 3.33333 8.62126 3.33333 8Z" stroke="#0BA5EC" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            </div>
            <div className="min-w-0">
              <h1 className="text-base md:text-lg font-semibold text-slate-900 truncate">{title}</h1>
              {subTitleElement ? (
                <div className="text-xs md:text-sm text-slate-600 hidden sm:block">{subTitleElement}</div>
              ) : subTitle ? (
                <p className="text-xs md:text-sm text-slate-600 hidden sm:block">{subTitle}</p>
              ) : null}
            </div>
          </div>
        </div>
        {actions && (
          <div className="flex items-center gap-2 flex-shrink-0">
            {actions}
          </div>
        )}
      </div>
    </div>
  );
}
